import { isBroker } from '../auth/redux/authActions';
import { dateToApi } from './redux/productActions';

const DEFAULT_BROKER_FLAGS = {
  car_insurance_marketing_enabled: false,
  home_insurance_marketing_enabled: false,
  marketing_enabled: false,
  insurance_marketing_options_enabled: false,
};

export const getMarketingFlags = (broker, channel) => {
  if (isBroker()) {
    const brokerMetadata = broker?.attributes?.metadata;

    return {
      car_insurance_marketing_enabled:
        brokerMetadata?.car_insurance_marketing_enabled ?? false,
      home_insurance_marketing_enabled:
        brokerMetadata?.home_insurance_marketing_enabled ?? false,
      marketing_enabled: brokerMetadata?.marketing_enabled ?? false,
      insurance_marketing_options_enabled:
        brokerMetadata?.insurance_marketing_options_enabled ?? false,
    };
  }
  const channelType = channel?.attributes?.channel_type;

  const defaultFlags =
    channelType === 'DIR'
      ? {
          car_insurance_marketing_enabled: true,
          home_insurance_marketing_enabled: true,
          marketing_enabled: true,
          insurance_marketing_options_enabled: true,
        }
      : DEFAULT_BROKER_FLAGS;

  if (channelType === 'B2C' && !broker?.attributes) {
    return {
      marketing_enabled: channel?.attributes?.metadata?.marketing?.enabled,
      insurance_marketing_options_enabled:
        channel?.attributes?.metadata?.insurance_marketing_options?.enabled,
      car_insurance_marketing_enabled:
        channel?.attributes?.metadata?.insurance_marketing_options
          ?.car_insurance_marketing_enabled,
      home_insurance_marketing_enabled:
        channel?.attributes?.metadata?.insurance_marketing_options
          ?.home_insurance_marketing_enabled,
    };
  }

  const isTracking = broker?.attributes?.broker_type === 'tracking' && !channel?.data;
  const isMarketingEnabled =
    broker?.attributes?.metadata?.marketing_enabled ?? isTracking;

  return broker?.attributes?.metadata
    ? {
        car_insurance_marketing_enabled:
          broker?.attributes?.metadata?.car_insurance_marketing_enabled,
        home_insurance_marketing_enabled:
          broker?.attributes?.metadata?.home_insurance_marketing_enabled,
        marketing_enabled: isMarketingEnabled,
        insurance_marketing_options_enabled:
          broker?.attributes?.metadata?.insurance_marketing_options_enabled ?? false,
      }
    : defaultFlags;
};

export const getTravellerMedical = (travellers) => {
  return travellers?.map((traveller) => {
    const screeningRegions = traveller?.screening?.meta?.regions;

    if (screeningRegions) {
      const newScreeningRegions = Object.keys(screeningRegions).reduce(
        (carry, regionNumber) => {
          if (['2', '3', '5'].includes(regionNumber) && !carry?.[1]) {
            carry['1'] = screeningRegions[regionNumber];
          }
          return carry;
        },
        screeningRegions,
      );

      return {
        ...traveller,
        screening: {
          ...traveller?.screening,
          meta: {
            ...traveller?.screening?.meta,
            regions: newScreeningRegions,
          },
        },
      };
    }
    return traveller;
  });
};

export const getValuesForSanctions = (travellers, address, schemeId) => {
  const travellerValuesForSanction = travellers.map((traveller) => {
    return {
      sanction_id: traveller.sanction_id,
      title: traveller.title ?? '',
      first_name: traveller.first_name ?? '',
      last_name: traveller.last_name ?? '',
      dob: dateToApi(traveller.dob) ?? '',
      address_country: address?.country ?? '',
      address_line_1: address?.line1 ?? '',
      address_line_2: address?.line2 ?? '',
      address_town: address?.town ?? '',
      address_county: address?.county ?? '',
      address_postcode: address?.postcode ?? '',
    };
  });

  return {
    meta: {
      insured: travellerValuesForSanction,
      scheme_id: schemeId,
    },
  };
};
